export const bannerMessage = {
    CLOSED_MERCHANT_ACCOUNT: 'This account has been closed'
};
